"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRequirementsTxtManifest = exports.getHandlerType = void 0;
const pathLib = require("path");
const supported_handler_types_1 = require("./supported-handler-types");
function getHandlerType(entity) {
    const targetFile = entity.scanResult.identity.targetFile;
    if (!targetFile) {
        return null;
    }
    const packageManagerOverride = entity.options.packageManager;
    if (packageManagerOverride) {
        return getTypeFromPackageManager(packageManagerOverride);
    }
    const path = pathLib.parse(targetFile);
    if (isRequirementsTxtManifest(targetFile)) {
        return supported_handler_types_1.SUPPORTED_HANDLER_TYPES.REQUIREMENTS;
    }
    else if (['Pipfile'].includes(path.base)) {
        return supported_handler_types_1.SUPPORTED_HANDLER_TYPES.PIPFILE;
    }
    else if (['pyproject.toml', 'poetry.lock'].includes(path.base)) {
        return supported_handler_types_1.SUPPORTED_HANDLER_TYPES.POETRY;
    }
    return null;
}
exports.getHandlerType = getHandlerType;
function isRequirementsTxtManifest(targetFile) {
    return targetFile.endsWith('.txt');
}
exports.isRequirementsTxtManifest = isRequirementsTxtManifest;
function getTypeFromPackageManager(packageManager) {
    switch (packageManager) {
        case 'pip':
            return supported_handler_types_1.SUPPORTED_HANDLER_TYPES.REQUIREMENTS;
        case 'poetry':
            return supported_handler_types_1.SUPPORTED_HANDLER_TYPES.POETRY;
        default:
            return null;
    }
}
//# sourceMappingURL=get-handler-type.js.map